// import _ from "lodash"
import rulesHandler from '@/services/rulesHandler';
import cartUtilities from './cartUtilities';
import cartVincols from './cartVincols';

import roundLodash from 'lodash/round';
import groupBy from 'lodash/groupBy';
import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';
import filter from 'lodash/filter';
import forEachLodash from 'lodash/forEach';
import remove from 'lodash/remove';

async function refreshCart(
  cartSettings,
  bet,
  bonusRules,
  odds_sources,
  combinableMarkets = [],
  percentageTaxValueOnWon = 0,
  allowIntegralLiveBet = false
) {
  // console.log('refreshing the cart, combinable markets are')
  // console.log(combinableMarkets)

  let newbet = {};
  const old_type = bet.type;
  bet.type = await cartUtilities.getCartType(bet, combinableMarkets);
  bet.context = await cartUtilities.getCartContext(bet);
  bet = await cartUtilities.resetBetAmount(
    bet,
    old_type,
    cartSettings.minAmount
  );

  switch (bet.type) {
    case 'single':
    case 'multiple':
      newbet = await updateTotalsMultiple(
        cartSettings,
        bet,
        bonusRules,
        percentageTaxValueOnWon
      );
      break;
    case 'integral':
      newbet = await updateTotalsIntegral(
        cartSettings,
        bet,
        bonusRules,
        percentageTaxValueOnWon
      );
      break;
    case 'system':
      newbet = await updateTotalsSystem(
        cartSettings,
        bet,
        bonusRules,
        odds_sources,
        percentageTaxValueOnWon
      );
      break;
  }

  const checkBet = await cartVincols.checkVincols(
    cartSettings,
    newbet,
    allowIntegralLiveBet
  );
  newbet.check = checkBet.check;
  newbet.errors = checkBet.errors;
  newbet.warnings = checkBet.warnings;
  newbet.errors_multi_info = checkBet.errors_multi_info;

  return newbet;
}

// OK
async function updateTotalsMultiple(
  cartSettings,
  bet,
  bonusRules,
  percentageTaxValueOnWon = 0
) {
  return new Promise(async (resolve, reject) => {
    // console.log('[DEBUG] updateTotalsMultiple ')
    // console.log(bet)

    // Reset other type after switch
    await cartUtilities.resetBetIntegralOrSystem(bet);

    // Calculate odd totals, multiplicity and base winning
    bet._multiple_detail.odds_total = await cartUtilities.getOddsTotal(
      bet.odds
    );

    const eventSourceSet = new Set();

    for (const odd of bet.odds) {
      eventSourceSet.add(odd.event_source);
    }

    const sourcesIdsArray = Array.from(eventSourceSet);

    bet._multiple_detail.multiplicity = sourcesIdsArray.length;
    bet._multiple_detail.winning = roundLodash(
      bet._multiple_detail.amount * bet._multiple_detail.odds_total,
      2
    );

    // Get Bonus from Bet
    const bonusDetail = await cartUtilities.getBonus(
      cartSettings,
      bet,
      bet._multiple_detail.multiplicity,
      bonusRules
    );

    if (bonusDetail.percentage > 0.0 && bonusDetail.oddsTotal > 0.0) {
      bet._multiple_detail.bonus_percentage = +bonusDetail.percentage;
      bet._multiple_detail.bonus = roundLodash(
        (bonusDetail.oddsTotal / 100) *
          +bonusDetail.percentage *
          bet._multiple_detail.amount,
        2
      );
    } else {
      bet._multiple_detail.bonus_percentage = 0.0;
      bet._multiple_detail.bonus = 0.0;
    }

    // Get Total with Bonus

    bet.percentageTaxValueOnWon = percentageTaxValueOnWon;

    const winning_total = roundLodash(
      bet._multiple_detail.winning + bet._multiple_detail.bonus,
      2
    );
    const profit = roundLodash(winning_total - bet._multiple_detail.amount, 2);
    const taxOnWonAmount = roundLodash(
      (profit * percentageTaxValueOnWon) / 100,
      2
    );

    bet._multiple_detail.winning_total = winning_total;
    bet._multiple_detail.profit = profit;

    bet._multiple_detail.expectedTaxOnWonAmount = taxOnWonAmount;
    bet._multiple_detail.expectedTotalTaxedWinnings = roundLodash(
      winning_total - taxOnWonAmount,
      2
    );
    bet._multiple_detail.expectedProfitTaxed = roundLodash(
      profit - taxOnWonAmount,
      2
    );

    resolve(bet);
  });
}

// OK
async function updateTotalsIntegral(
  cartSettings,
  bet,
  bonusRules,
  percentageTaxValueOnWon = 0
) {
  return new Promise(async (resolve, reject) => {
    // Setup Amount
    const amount = bet._integral_detail.amount;
    let single_amount = 1;
    let searchMin = undefined;
    let searchMax = undefined;

    // Group odds by event
    const groupByEventSource = await groupBy(bet.odds, 'event_source');

    const betOddsTotal = await cartUtilities.getOddsTotalMinMax(
      groupByEventSource
    );

    bet._integral_detail.odds_total_min = betOddsTotal.odds_total_min;
    bet._integral_detail.odds_total_max = betOddsTotal.odds_total_max;
    bet._integral_detail.multiplicity = Object.keys(groupByEventSource).length;

    const resultParts = await cartUtilities.getIntegralParts(
      groupByEventSource
    );

    bet._integral_detail.combinations = resultParts.combinations;
    if (cartSettings.integralDivided) {
      bet._integral_detail.amount_total = bet._integral_detail.amount;
      single_amount = roundLodash(
        bet._integral_detail.amount / bet._integral_detail.combinations,
        2
      );
    } else {
      bet._integral_detail.amount_total = roundLodash(
        bet._integral_detail.amount * bet._integral_detail.combinations,
        2
      );
      single_amount = bet._integral_detail.amount;
    }

    bet.integral_parts = await cartUtilities.refactorIntegralParts(
      resultParts.integralParts,
      single_amount,
      cartSettings,
      bonusRules,
      bet._integral_detail.multiplicity,
      bet.context
    );

    // bet._integral_detail.bonus_percentage = bet.integral_parts[0].bonus_percentage
    // if(bet._integral_detail.bonus_percentage > 0){
    searchMin = minBy(bet.integral_parts, o => {
      return o.bonus;
    });
    searchMax = maxBy(bet.integral_parts, o => {
      return o.bonus;
    });
    // }

    bet._integral_detail.bonus_min = searchMin ? searchMin.bonus : 0.0;
    bet._integral_detail.bonus_max = searchMax ? searchMax.bonus : 0.0;

    bet._integral_detail.winning_min = roundLodash(
      single_amount * bet._integral_detail.odds_total_min,
      2
    );
    bet._integral_detail.winning_max = roundLodash(
      single_amount * bet._integral_detail.odds_total_max,
      2
    );

    bet.percentageTaxValueOnWon = percentageTaxValueOnWon;

    const winning_total_min = roundLodash(
      bet._integral_detail.winning_min + bet._integral_detail.bonus_min,
      2
    );
    const winning_total_max = roundLodash(
      bet._integral_detail.winning_max + bet._integral_detail.bonus_max,
      2
    );

    const profit_min = roundLodash(winning_total_min - amount, 2);
    const profit_max = roundLodash(winning_total_max - amount, 2);

    let taxOnWonAmountMin = roundLodash(
      (profit_min * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountMin = taxOnWonAmountMin >= 0 ? taxOnWonAmountMin : 0;

    let taxOnWonAmountMax = roundLodash(
      (profit_max * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountMax = taxOnWonAmountMax >= 0 ? taxOnWonAmountMax : 0;

    bet._integral_detail.winning_total_min = winning_total_min;
    bet._integral_detail.winning_total_max = winning_total_max;

    bet._integral_detail.profit_min = profit_min;
    bet._integral_detail.profit_max = profit_max;

    bet._integral_detail.taxOnWonAmountMin = taxOnWonAmountMin;
    bet._integral_detail.taxOnWonAmountMax = taxOnWonAmountMax;

    bet._integral_detail.winning_total_min_taxed = roundLodash(
      winning_total_min - taxOnWonAmountMin,
      2
    );
    bet._integral_detail.winning_total_max_taxed = roundLodash(
      winning_total_max - taxOnWonAmountMax,
      2
    );

    bet._integral_detail.profit_min_taxed = roundLodash(
      profit_min - taxOnWonAmountMin,
      2
    );
    bet._integral_detail.profit_max_taxed = roundLodash(
      profit_max - taxOnWonAmountMax,
      2
    );

    // Switch off for Performance
    bet.integral_parts = [];

    resolve(bet);
  });
}

// OK
async function updateTotalsSystem(
  cartSettings,
  bet,
  bonusRules,
  odds_sources,
  percentageTaxValueOnWon = 0
) {
  return new Promise(async (resolve, reject) => {
    // Check Bases
    bet._system_detail.fixed_bases = filter(
      bet._system_detail.fixed_bases,
      base => {
        return odds_sources.includes(base);
      }
    );

    // Get all combo
    const systemDetail = await cartUtilities.getSystemComboDetail(
      bet.odds,
      bet.system_parts,
      cartSettings.minAmount,
      bet._system_detail.fixed_bases
    );
    bet.system_parts = systemDetail.system_combo;
    bet._system_detail.combinations = systemDetail.combinations;

    // setup amount
    if (bet._system_detail.combinations > 0) {
      if (bet._system_detail.amount_system_equal != null) {
        bet.system_parts = await cartUtilities.setAmountSystemComboDetail(
          bet.system_parts,
          bet._system_detail.amount_system_equal
        );
        bet._system_detail.amount_system = roundLodash(
          bet._system_detail.amount_system_equal *
            bet._system_detail.combinations,
          2
        );
      } else if (bet._system_detail.amount_system_to_divide != null) {
        const amount_combinations = roundLodash(
          bet._system_detail.amount_system_to_divide /
            bet._system_detail.combinations,
          2
        );
        bet.system_parts = await cartUtilities.setAmountSystemComboDetail(
          bet.system_parts,
          amount_combinations
        );
        bet._system_detail.amount_system = roundLodash(
          amount_combinations * bet._system_detail.combinations,
          2
        );
      }
    }

    const rafactoredBet = await cartUtilities.refactorSystemBet(
      bet,
      cartSettings,
      bonusRules
    );

    const totals = await cartUtilities.getSystemTotalAmount(
      systemDetail.system_combo
    );

    bet.percentageTaxValueOnWon = percentageTaxValueOnWon;

    const amountPlayedSystem = bet._system_detail.amount_system;

    const winning_min = totals.winning_min;
    const winning_max = totals.winning_max;

    const winning_total_min = totals.winning_total_min;
    const winning_total_max = totals.winning_total_max;

    const winning_all = totals.winning_all;
    const winning_all_total = totals.winning_all_total;

    const profit_min = roundLodash(winning_min - amountPlayedSystem, 2);
    const profit_max = roundLodash(winning_max - amountPlayedSystem, 2);

    const profit_total_min = roundLodash(
      winning_total_min - amountPlayedSystem,
      2
    );
    const profit_total_max = roundLodash(
      winning_total_max - amountPlayedSystem,
      2
    );

    const profit_all = roundLodash(winning_all - amountPlayedSystem, 2);
    const profit_all_total = roundLodash(
      winning_all_total - amountPlayedSystem,
      2
    );

    let taxOnWonAmountMin = roundLodash(
      (profit_min * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountMin = taxOnWonAmountMin >= 0 ? taxOnWonAmountMin : 0;

    let taxOnWonAmountMax = roundLodash(
      (profit_max * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountMax = taxOnWonAmountMax >= 0 ? taxOnWonAmountMax : 0;

    let taxOnWonAmountTotalMin = roundLodash(
      (profit_total_min * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountTotalMin =
      taxOnWonAmountTotalMin >= 0 ? taxOnWonAmountTotalMin : 0;

    let taxOnWonAmountTotalMax = roundLodash(
      (profit_total_max * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountTotalMax =
      taxOnWonAmountTotalMax >= 0 ? taxOnWonAmountTotalMax : 0;

    let taxOnWonAmountAll = roundLodash(
      (profit_all * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountAll = taxOnWonAmountAll >= 0 ? taxOnWonAmountAll : 0;

    let taxOnWonAmountAllTotal = roundLodash(
      (profit_all_total * percentageTaxValueOnWon) / 100,
      2
    );
    taxOnWonAmountAllTotal =
      taxOnWonAmountAllTotal >= 0 ? taxOnWonAmountAllTotal : 0;

    rafactoredBet._system_detail.winning_min_taxed = roundLodash(
      winning_min - taxOnWonAmountMin,
      2
    );
    rafactoredBet._system_detail.winning_max_taxed = roundLodash(
      winning_max - taxOnWonAmountMax,
      2
    );
    rafactoredBet._system_detail.winning_total_min_taxed = roundLodash(
      winning_total_min - taxOnWonAmountTotalMin,
      2
    );
    rafactoredBet._system_detail.winning_total_max_taxed = roundLodash(
      winning_total_max - taxOnWonAmountTotalMax,
      2
    );
    rafactoredBet._system_detail.winning_all_taxed = roundLodash(
      winning_all - taxOnWonAmountAll,
      2
    );
    rafactoredBet._system_detail.winning_all_total_taxed = roundLodash(
      winning_all_total - taxOnWonAmountAllTotal,
      2
    );

    rafactoredBet._system_detail.amount_system = totals.amount_system;
    rafactoredBet._system_detail.winning_min = winning_min;
    rafactoredBet._system_detail.winning_max = winning_max;
    rafactoredBet._system_detail.winning_total_min = winning_total_min;
    rafactoredBet._system_detail.winning_total_max = winning_total_max;
    rafactoredBet._system_detail.bonus_min = totals.bonus_min;
    rafactoredBet._system_detail.bonus_max = totals.bonus_max;
    rafactoredBet._system_detail.winning_all = winning_all;
    rafactoredBet._system_detail.winning_all_total = winning_all_total;
    rafactoredBet._system_detail.valid_combinations_all =
      totals.valid_combinations_all;

    rafactoredBet._system_detail.taxOnWonAmountMin = taxOnWonAmountMin;
    rafactoredBet._system_detail.taxOnWonAmountMax = taxOnWonAmountMax;
    rafactoredBet._system_detail.taxOnWonAmountTotalMin =
      taxOnWonAmountTotalMin;
    rafactoredBet._system_detail.taxOnWonAmountTotalMax =
      taxOnWonAmountTotalMax;
    rafactoredBet._system_detail.taxOnWonAmountAll = taxOnWonAmountAll;
    rafactoredBet._system_detail.taxOnWonAmountAllTotal =
      taxOnWonAmountAllTotal;

    // Switch for performance
    forEachLodash(rafactoredBet.system_parts, sys_part => {
      sys_part.combinationsOdds = [];
    });

    resolve(rafactoredBet);
  });
}

// Utility Functions
async function setupAmount(bet) {
  if (bet._system_detail.combinations > 0) {
    if (bet._system_detail.amount_system_equal != null) {
      bet.system_parts = await setAmountSystemComboDetail(
        bet.system_parts,
        bet._system_detail.amount_system_equal
      );
      bet._system_detail.amount_system = roundLodash(
        bet._system_detail.amount_system_equal *
          bet._system_detail.combinations,
        2
      );
      return bet;
    } else if (bet._system_detail.amount_system_to_divide != null) {
      const amount_combinations = roundLodash(
        bet._system_detail.amount_system_to_divide /
          bet._system_detail.combinations,
        2
      );
      bet.system_parts = await setAmountSystemComboDetail(
        bet.system_parts,
        amount_combinations
      );
      bet._system_detail.amount_system = roundLodash(
        amount_combinations * bet._system_detail.combinations,
        2
      );
      return bet;
    }
  } else {
    return bet;
  }
}

async function refactorOdd(odd, event, sport, category, tournament) {
  delete odd.type_change;
  delete odd.outcome_status_to_refresh;
  delete odd.outcome_value_to_refresh;

  odd.event_description = event.description;
  odd.time = event.time;
  odd.event_source = event.id;
  odd.sport = sport;
  odd.category = category;
  odd.tournament = tournament;
  odd.quickbet = event.quickbet;
  return odd;
}

async function refactorOddV3(market, odd, event, sport, category, tournament) {
  // console.log('refactor odd v3 ')
  // console.log({
  //     market:market,
  //     odd:odd,
  //     event:event,
  //     sport:sport,
  //     category:category,
  //     tournament:tournament
  // })

  delete odd.type_change;
  delete odd.outcome_status_to_refresh;
  delete odd.outcome_value_to_refresh;

  if (odd.type != 'antepost') {
    odd.event_description = event.home + ' - ' + event.away;
  }

  odd.time = new Date(event.scheduled).getTime();
  odd.event_source = event.id;
  odd.sport = sport;
  odd.category = category;
  odd.tournament = tournament;
  odd.quickbet = event.quickbet; // antepost non lo tiene e normale ?

  const multipli_min =
    odd.multiplicityMin != null ? odd.multiplicityMin : market.multiplicityMin;
  const multipli_max =
    odd.multiplicityMax != null ? odd.multiplicityMax : market.multiplicityMax;

  odd.market_unique_id =
    odd.unique_id_market != null ? odd.unique_id_market : market.unique_id;
  odd.multiplicity = multipli_min + '-' + multipli_max;
  odd.multiplicity_min =
    odd.multiplicityMin != null
      ? odd.multiplicityMin.toString()
      : market.multiplicityMin.toString();
  odd.multiplicity_max =
    odd.multiplicityMax != null
      ? odd.multiplicityMax.toString()
      : market.multiplicityMax.toString();
  odd.market_name =
    odd.market_name != null ? odd.market_name : market.marketName;
  odd.id_market = odd.id_market != null ? odd.id_market : market.id;
  return odd;
}

async function removeOldOddFromCart(
  cartSettings,
  bet,
  bonusRules,
  odds_sources
) {
  if (bet.odds.length > 0) {
    const now = new Date().getTime();

    const prematch = remove(bet.odds, function (n) {
      return n.time - 3 * 3600000 < now && n.type == 'prematch';
    });

    const live = remove(bet.odds, function (n) {
      return now + 3 * 3600000 - n.time > 3 * 3600000 && n.type == 'live';
    });
  }

  return await refreshCart(cartSettings, bet, bonusRules, odds_sources);

  // // if(prematch.length>0){
  //     console.log(prematch)
  // // }
  //
  // // if(live.length>0){
  //     console.log(live)
  // // }
}

export default {
  refreshCart,
  refactorOdd,
  refactorOddV3,
  removeOldOddFromCart,
  updateTotalsMultiple,
  updateTotalsIntegral,
  updateTotalsSystem
};
